import { CMS_PAGES } from 'modules/cmsPages/actionTypes';

const getPageData = () => (dispatch, getState, { api }) => {
  dispatch({
    type: CMS_PAGES.CMS_PAGES_REQUEST,
    payload: {},
    test: api
      .post(`cmsPage.json`)
      .then(res => {
        dispatch({
          type: CMS_PAGES.CMS_PAGES_SUCCESS,
          payload: res.data,
        });
        return res.data;
      })
      .catch(error => {
        dispatch({
          type: CMS_PAGES.CMS_PAGES_FAILURE,
          error,
        });
      }),
  });
};

export const CmsPagesActions = {
  getPageData,
};
